import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllRavenAuthorizationResponseCodeDef = () => get(url.RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_GET)